.declinedDiv {
    padding: 10px;
    background: #f3cfd2;
    border-radius: 13px;
    font-size: 14px;
    width: 100%;
    margin-top: 3px;
    margin-bottom: 3px;
}

.dialogContentRow{
  font-size : 15px;
  justify-content: space-between;
}